<template>
  <div style="float: left;margin-top: 10px;">
    <div class="m-form__group m-form__group--inline">
      <div class="m-form__label">
        <label style="width: 100px;text-align:right;">{{label}}：</label>
      </div>
      <div class="m-form__control">
        <el-date-picker v-model="value" :type="pickertype" :value-format="valueformat" placeholder="选择日期" @change="currentSel">
        </el-date-picker>
      </div>
    </div>
    <div class="d-md-none m--margin-bottom-10"></div>
  </div>
</template>

<script>
export default {
  name: 'SearchDateTimeText',
  data () {
    return {
      value: ''
    }
  },
  props: {
    label: {
      type: String
    },
    pickertype: {
      type: String
    },
    valueformat: {
      type: String
    }
  },
  watch: {
    value (nv) {
      console.log(nv)
      this.value = nv
    }
  },
  methods: {
    currentSel: function (selVal) {
      console.log(selVal)
      this.$emit('input', selVal)
    }
  }
}
</script>

<style>
</style>
